<div class="picker">
  <div class="picker-head">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="picker-search">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [placeholder]="'editor.picker.search' | translate" [attr.aria-label]="'editor.picker.search' | translate" [ngModel]="query()"
        (ngModelChange)="onSearch($event)" />
    </mat-form-field>

    <lib-button color="none" textColor="muted" icon="close" (click)="closed.emit()"
      [tooltip]="'form.close' | translate"></lib-button>
  </div>

  @if (locked) {
  <p class="picker-note">
    <mat-icon>info</mat-icon>
    {{ 'editor.picker.locked' | translate }}
  </p>
  }

  <div class="picker-list">
    @for (source of sources; track source.collection) {
    <section class="source" [class.disabled]="isDisabled(source.collection)" [class.open]="isOpen(source.collection)">
      <button type="button" class="source-head" (click)="toggleSource(source.collection)"
        [disabled]="isDisabled(source.collection)">
        <span class="source-icon"><mat-icon>{{ source.icon }}</mat-icon></span>

        <span class="source-text">
          <span class="source-title">
            <span class="source-label">{{ 'editor.sources.' + source.collection + '.label' | translate }}</span>
            <code class="source-technical">{{ source.technical }}</code>
          </span>

          <span class="source-hint">{{ 'editor.sources.' + source.collection + '.hint' | translate }}</span>
        </span>

        <mat-icon class="chevron">expand_more</mat-icon>
      </button>

      @if (isOpen(source.collection)) {
      <div class="source-body">
        @if (loading()[source.collection]) {
        <!-- The spinner says it is loading -->
        <div class="picker-loading"><app-spinner [diameter]="16"></app-spinner></div>
        }

        @for (group of visibleGroups(source.collection); track group.key) {
        <div class="group">
          @if (group.key !== 'general') {
          <button type="button" class="group-head" (click)="toggleGroup(source.collection, group)">
            <mat-icon class="chevron" [class.open]="isGroupOpen(source.collection, group)">chevron_right</mat-icon>

            <span class="group-text">
              <span class="group-label">{{ groupLabel(source.collection, group) }}</span>
              @if (groupHint(group)) {
              <span class="group-hint">{{ groupHint(group) }}</span>
              }
            </span>

            <!-- Its fields, then its measures (documents) when the API counts them -->
            <span class="group-counts">
              <span class="group-count" [matTooltip]="'editor.picker.fields' | translate">{{ group.fields.length }}</span>
              @if (group.count !== undefined) {
              <span class="group-count measures" [matTooltip]="'editor.picker.measures' | translate">{{ formatCount(group.count) }}</span>
              }
            </span>
          </button>
          }

          @if (isGroupOpen(source.collection, group)) {
          <div class="fields" [class.nested]="group.key !== 'general'">
            @for (field of group.fields; track field.path) {
            <button type="button" class="field-row" (click)="pick(source.collection, group, field)">
              <app-field-label [path]="field.path" [collection]="source.collection"></app-field-label>
              <mat-icon class="field-add">add</mat-icon>
            </button>
            }
          </div>
          }
        </div>
        } @empty {
        @if (!loading()[source.collection]) {
        <p class="picker-empty">{{ 'editor.picker.empty' | translate }}</p>
        }
        }
      </div>
      }
    </section>
    }
  </div>
</div>